import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

export default function YesNoAnswer({ question, responseHandler, error, helperText, disabled, validateField }) {
    const q = question;
    const id = question.questionID;

    const [value, setValue] = React.useState(q.response.responseText === null ? '' : q.response.responseText);

    function handleClick(event) {
        let toVal;
        /*
         To support certain validations,
           this is three-state control that supports deselection:
            Yes (1)
            No (0)
            Unanswered (null)
        */
        if (event.target.value === value) {
            setValue((toVal = ''));
        } else {
            setValue((toVal = event.target.value));
        }
        responseHandler(id, toVal && toVal.length ? toVal : null, event);
        validateField();
    }

    return (
        <div className="questionnaire-body">
            <FormControl
                classes={disabled ? { root: 'questionnaire-body disabled' } : { root: 'questionnaire-body' }}
                component="div"
                key={`a${id}YesNo`}
                disabled={disabled}
                error={Boolean(error)}
            >
                {question.question}
                <RadioGroup
                    // aria-label={question.questionGroup.alias}
                    name={question.questionGroup.alias}
                    error={`${error}`}
                    value={value}
                    style={{ display: 'flex', flexDirection: 'row' }}
                >
                    <FormControlLabel
                        key={`a${id}Yes`}
                        value="1"
                        control={<Radio onClick={handleClick} color={error ? '' : 'primary'} />}
                        label="Yes"
                        style={{ display: 'flex' }}
                    />
                    <FormControlLabel
                        key={`a${id}No`}
                        value="0"
                        control={<Radio onClick={handleClick} color={error ? '' : 'primary'} />}
                        label="No"
                        style={{ display: 'flex' }}
                        // classes={{ root: classes.radio, checked: classes.checked }}
                    />
                </RadioGroup>
                <FormHelperText
                    id={`a${id}-helper-text`}
                    // classes={{ root: classes.helperText }}
                >
                    {helperText}
                </FormHelperText>
            </FormControl>
        </div>
    );
}
